export default class DataOrder {
  constructor(bRoot) {
    this.bRoot = bRoot;
    this.app = "/data/";
    this.initialize = this.initialize.bind(this);
  }

  async search(
    campaign_id,
    client_id,
    state_id,
    crop_id,
    salesman_id,
    dealer_id,
    order,
    page
  ) {
    let endpoint =
      this.app +
      "orders_hierarchy_list/" +
      campaign_id.toString() +
      "/" +
      client_id.toString() +
      "/" +
      state_id.toString() +
      "/" +
      crop_id.toString() +
      "/" +
      salesman_id.toString() +
      "/" +
      dealer_id.toString() +
      "/" +
      (order ? order : "");

    return await this.bRoot.search(endpoint, null, null, null, page);
  }

  async get(campaign_id, order_id) {
    let endpoint =
      this.app +
      "orders_hierarchy/" +
      campaign_id.toString() +
      "/0/0/0/0/0/" +
      order_id.toString() +
      "/-backend_code";

    let order = await this.bRoot.search(endpoint, null, null, null, 1);
    return order.data.results[0];
  }

  async getCampaigns() {
    // eslint-disable-next-line
    let campaigns = await this.bRoot.search(this.app + "campaigns", null, "code", "orders_enabled__in=S,D");
    for (let camp in campaigns.data.results) {
      if (
        this.bRoot.auth.current_level != 0 &&
        campaigns.data.results[camp].orders_enabled == "D"
      ) {
        campaigns.data.results.splice(camp, 1);
      }
    }
    return campaigns;
  }

  async getDocuments() {
    // eslint-disable-next-line
    return await this.bRoot.search(this.app + "order_documents", null, "id", null);
  }

  async getCrops() {
    // eslint-disable-next-line
    return await this.bRoot.search(this.app + "crops", null, "code", null);
  }

  async getStates() {
    // eslint-disable-next-line
    return await this.bRoot.search(this.app + "order_states", null, "code", null);
  }

  async getSalesMethods() {
    // eslint-disable-next-line
    return await this.bRoot.search(this.app + "sale_methods", null, "code", null);
  }

  async getPaymentConditions() {
    let paymentConditions = await this.bRoot.search(
      this.app + "payment_conditions",
      null,
      "code",
      null
    );
    return paymentConditions.data.results.map(object => {
      object.display_description = object.code + " - " + object.description;
      return object;
    });
  }

  async getDiscountCode(code) {
    let DiscountCode = await this.bRoot.search(
      this.app + "discount_codes",
      null,
      "code",
      "code=" + code.toString()
    );
    if (DiscountCode.data) {
      return DiscountCode.data.results[0];
    }
  }

  async getRateValue() {
    let usd_rate_endpoint =
      this.app +
      "rate_values" +
      "/" +
      "to_date" +
      "/" +
      "USD" +
      "/" +
      this.bRoot.moment().format("YYYY-MM-DD");

    let RateValue = await this.bRoot.search(
      usd_rate_endpoint,
      null,
      "code",
      null
    );
    if (RateValue.data) {
      return RateValue.data[0];
    } else {
      return null;
    }
  }

  async getDiscountScales(order) {
    let filterString = "discount_code=2";
    if (!order.client_object) {
      return null;
    } else {
      if (!order.client_object.category_object) {
        return null;
      } else {
        filterString =
          filterString +
          "&category__id=" +
          order.client_object.category_object.id;
      }
    }
    if (!order.crop_object) {
      return null;
    } else {
      filterString =
        filterString + "&crop__id=" + order.crop_object.id.toString();
    }
    filterString =
      filterString +
      "&from_date__lte=" +
      this.bRoot.moment(order.date).format("YYYY-MM-DD") +
      " 00:00:00" +
      "&to_date__gte=" +
      this.bRoot.moment(order.date).format("YYYY-MM-DD") +
      " 00:00:00";

    let discountScales = await this.bRoot.searchAll(
      "data/discounts",
      null,
      "to_quantity",
      filterString
    );
    return discountScales;
  }

  async initialize(client, campaign, crop, document_code) {
    let response = await this.bRoot.search(
      "data/order_documents",
      null,
      null,
      "code=" + document_code
    );

    let order_document =
      response.data.results.length === 1 ? response.data.results[0] : null;
    let object = {
      url: null,
      id: null,
      code: null,
      commercial_person: this.bRoot.appInfo.commercial_person.url,
      commercial_person_name: this.bRoot.appInfo.commercial_person.person.name,
      salesman: null,
      dealer: null,
      dealer_object: null,
      dealer_name: null,
      dealer_id: null,
      dealer_code: null,
      date: this.bRoot.moment().format("YYYY-MM-DD"),
      date_formatted: this.bRoot.moment().format("DD/MM/YYYY"),
      document: order_document.url,
      document_object: { ...order_document },
      sale_method: null,
      broker: null,
      broker_name: null,
      broker_id: 0,
      broker_code: null,
      requires_broker: false,
      campaign_prior_quantity: 0,
      campaign_total_quantity: 0,
      total_quantity: 0,
      advance_dispatch: false,
      comments: null,
      internal_comments: null,
      backend_code: null,
      delivery_contact_name: null,
      delivery_contact_phone: null,
      delivery_date_from: this.bRoot.moment().format("YYYY-MM-DD"),
      show_picker_from: false,
      show_picker_to: false,
      can_edit: true,
      can_request_invoicing: false,
      can_authorize_level_1: false,
      can_authorize_level_2: false,
      has_company_discount: false,
      fidelity_plan: false,
      errors: null,
      order_items: []
    };
    object.state = null;
    object = await this.setClient(object, client);
    object = await this.setPaymentCondition(
      object,
      null,
      client ? client.paymentCondition : null
    );
    /*Evaluar si el comercial logueado es agente del cliente en cuestión y auto completar*/
    object = await this.setDealer(object, null);
    /* setCampaing limpia ítems preexistentes y agrega uno nuevo*/
    object = await this.setCampaign(object, campaign);
    object = await this.setCrop(object, crop);
    object = await this.olpTotalize(object);
    return object;
  }

  async setClient(order, client) {
    order.client_object = client;
    order.client = client ? client.url : null;
    order.client_id = client ? client.id : 0;
    order.client_name = client ? client.name : null;
    // eslint-disable-next-line
    order.client_identification_type_code = client ? client.identification_type_code : null;
    order.client_identification = client ? client.identification : null;
    if (order.document_object.inventory_has_client) {
      order.address = null;
    } else {
      order.address = client ? client.delivery_address : null;
    }
    order = await this.setPaymentCondition(
      order,
      null,
      // eslint-disable-next-line
      client ? client.payment_condition : null
    );
    order = await this.setPostalCode(
      order,
      null,
      // eslint-disable-next-line
      client ? client.delivery_postal_code : null
    );
    //eslint-disable-next-line
    order = await this.setSaleConditionAllItems(order);
    if (order.campaign_object && order.crop_object && order.client_object) {
      order = await this.setCampaignPriorQuantity(order);
    }
    return order;
  }

  async setCampaign(order, campaign, campaignUrl) {
    if (!campaign && campaignUrl) {
      try {
        this.bRoot.disableAlerts = true;
        campaign = await this.bRoot.getObjectByURL(campaignUrl);
      } catch {
        campaign = null;
      } finally {
        this.bRoot.disableAlerts = false;
      }
    }
    order.campaign_object = campaign;
    order.campaign = campaign ? campaign.url : null;
    order.campaign_id = campaign ? campaign.id : 0;
    order.campaign_code = campaign ? campaign.code : null;
    order = await this.setCropCampaignParameters(order);
    order = await this.clearItems(order);
    if (order.campaign_object && order.crop_object && order.client_object) {
      order = await this.setCampaignPriorQuantity(order);
    }
    return order;
  }

  async setCrop(order, crop, cropUrl) {
    if (!crop && cropUrl) {
      try {
        this.bRoot.disableAlerts = true;
        crop = await this.bRoot.getObjectByURL(cropUrl);
      } catch {
        crop = null;
      } finally {
        this.bRoot.disableAlerts = false;
      }
    }
    order.crop_object = crop;
    order.crop = crop ? crop.url : null;
    order.crop_id = crop ? crop.id : 0;
    order.crop_code = crop ? crop.code : null;
    order.crop_description = crop ? crop.description : null;
    order = await this.setCropCampaignParameters(order);
    order = await this.clearItems(order);
    if (order.campaign_object && order.crop_object && order.client_object) {
      order = await this.setCampaignPriorQuantity(order);
    }
    return order;
  }

  async setDealer(order, dealer, dealerUrl) {
    if (!dealer && dealerUrl) {
      try {
        this.bRoot.disableAlerts = true;
        dealer = await this.bRoot.getObjectByURL(dealerUrl);
      } catch {
        dealer = null;
      } finally {
        this.bRoot.disableAlerts = false;
      }
    }
    order.dealer_object = dealer;
    order.dealer = dealer ? dealer.url : null;
    order.dealer_id = dealer ? dealer.id : 0;
    order.dealer_code = dealer ? dealer.code : null;
    order.dealer_name = dealer ? dealer.name : null;
    order = await this.clearItems(order);
    return order;
  }

  async setPaymentCondition(order, paymentCondition, paymentConditionUrl) {
    if (!paymentCondition && paymentConditionUrl) {
      try {
        this.bRoot.disableAlerts = true;
        paymentCondition = await this.bRoot.getObjectByURL(paymentConditionUrl);
      } catch {
        paymentCondition = null;
      } finally {
        this.bRoot.disableAlerts = false;
      }
    }
    order.payment_condition_object = paymentCondition;
    order.payment_condition = paymentCondition ? paymentCondition.url : null;
    order.payment_condition_id = paymentCondition ? paymentCondition.id : 0;
    order.requires_broker = false;
    if (paymentCondition) {
      if (paymentCondition.payment_form_object) {
        if (paymentCondition.payment_form_object.requires_broker) {
          order.requires_broker =
            paymentCondition.payment_form_object.requires_broker;
        }
      }
    }
    if (order.requires_broker === false) {
      order = await this.setBroker(order);
    }
    order.interest = paymentCondition ? paymentCondition.interest : 0;
    // eslint-disable-next-line
    order.payment_condition_description =  (paymentCondition ? paymentCondition.description : null);
    order.payment_condition_term = paymentCondition ? paymentCondition.term : 0;
    order = await this.setSaleConditionAllItems(order);
    return order;
  }

  async setBroker(order, broker, brokerUrl) {
    if (!broker && brokerUrl) {
      try {
        this.bRoot.disableAlerts = true;
        broker = await this.bRoot.getObjectByURL(brokerUrl);
      } catch {
        broker = null;
      } finally {
        this.bRoot.disableAlerts = false;
      }
    }
    order.broker = broker ? broker.url : null;
    order.broker_id = broker ? broker.id : 0;
    order.broker_code = broker ? broker.code : null;
    order.broker_name = broker ? broker.name : null;
    return order;
  }

  async setPostalCode(order, postalCode, postalCodeUrl) {
    if (order.document_object.inventory_has_client) {
      order.postal_code_object = null;
      order.postal_code = null;
      order.postal_code_code = null;
      order.postal_code_description = null;
      order.postal_code_allow_delivery = null;
    } else {
      if (!postalCode && postalCodeUrl) {
        try {
          this.bRoot.disableAlerts = true;
          postalCode = await this.bRoot.getObjectByURL(postalCodeUrl);
        } catch {
          postalCode = null;
        } finally {
          this.bRoot.disableAlerts = false;
        }
      }
      order.postal_code_object = postalCode;
      order.postal_code = postalCode ? postalCode.url : null;
      order.postal_code_code = postalCode ? postalCode.postal_code : null;
      order.postal_code_description = postalCode ? postalCode.description : null; //eslint-disable-line  
      order.postal_code_allow_delivery = postalCode ? !postalCode.disabled_delivery : true; //eslint-disable-line  
    }
    return order;
  }

  async setCropCampaignParameters(order) {
    let defData = {
      max_discount: 0,
      delivery_period_size: 0,
      delivery_start_date: order.date,
      delivery_end_date: order.date
    };
    if (!order.campaign_object || !order.crop_object) {
      order.crop_campaign_parameters_object = defData;
    } else {
      let endpoint = "/data/crop_campaign_parameters";
      let filterString =
        "crop__id=" +
        order.crop_object.id.toString() +
        "&&campaign__id=" +
        order.campaign_object.id.toString();
      let response = await this.bRoot.search(
        endpoint,
        null,
        null,
        filterString
      );
      order.crop_campaign_parameters_object =
        response.data.length === 1 ? response.data[0] : defData;
    }
    let res = await this.DeliveryDateFromChange(order);
    order = res.order;
    return order;
  }

  async setCampaignPriorQuantity(order) {
    let advance_dispatch = order.advance_dispatch;
    let endpoint =
      "/data/accumulated_sales/" +
      (order.campaign_id ? order.campaign_id.toString() + "/" : "0/") +
      (order.client_id ? order.client_id.toString() + "/" : "0/") +
      (order.crop_id ? order.crop_id.toString() + "/" : "0/") +
      (order.id ? order.id.toString() : "0");

    let response = await this.bRoot.search(endpoint);
    if (response.data.length === 1) {
      order.campaign_prior_quantity = response.data[0].prior_quantity;
      order.fidelity_plan = response.data[0].fidelity_plan;
    } else {
      order.campaign_prior_quantity = 0;
      order.fidelity_plan = false;
    }
    if (order.fidelity_plan == false) {
      order.advance_dispatch = false;
    }
    if (advance_dispatch != order.advance_dispatch) {
      order = await this.advanceDispatchChange(order);
    }
    order = await this.setCampaignTotalQuantity(order);
    return order;
  }

  async setCampaignTotalQuantity(order) {
    let order_quantity = 0;
    for (let item of order.order_items) {
      order_quantity += Number(item.quantity);
    }
    order.campaign_total_quantity = (Number(order.campaign_prior_quantity) + Number(order_quantity)).toFixed(2); //eslint-disable-line
    return order;
  }

  async setOrderDocument(order, orderDocument, orderDocumentUrl) {
    if (!orderDocument && orderDocumentUrl) {
      try {
        this.bRoot.disableAlerts = true;
        orderDocument = await this.bRoot.getObjectByURL(orderDocumentUrl);
      } catch {
        orderDocument = null;
      } finally {
        this.bRoot.disableAlerts = false;
      }
    }
    order = await this.clearItems(order);
    order.document = orderDocument.url;
    order.document_object = { ...orderDocument };
    if (orderDocument.inventory_has_client) {
      order.delivery_contact_name = null;
      order.delivery_contact_phone = null;
      order.delivery_date_from = null;
      order.delivery_date_from_formatted = null;
      order.delivery_date_to = null;
      order.delivery_date_to_formatted = null;
    } else {
      order.delivery_date_from = this.bRoot.moment().format("YYYY-MM-DD");
      order.delivery_date_from_formatted = this.bRoot.moment().format("DD/MM/YYYY"); //eslint-disable-line
      order.delivery_date_to = this.bRoot.moment().format("YYYY-MM-DD");
      order.delivery_date_to_formatted = this.bRoot.moment().format("DD/MM/YYYY"); //eslint-disable-line
    }
    order = await this.setClient(order, null);
    return order;
  }

  async advanceDispatchChange(order) {
    order = await this.setSaleConditionAllItems(order);
    return order;
  }

  async totalQuantityChange(order) {
    order = await this.setSaleConditionAllItems(order);
    return order;
  }

  async DeliveryDateFromChange(order) {
    order.delivery_date_from_formatted = this.bRoot.moment(order.delivery_date_from).format("DD/MM/YYYY"); //eslint-disable-line
    order.delivery_date_to_formatted = this.bRoot.moment(order.delivery_date_from).add(order.crop_campaign_parameters_object.delivery_period_size, 'day').format("YYYY-MM-DD"); //eslint-disable-line
    order = await this.setDeliveryDateFromAllItems(order);
    order = await this.DeliveryDateToChange(order);
    return order;
  }

  async DeliveryDateToChange(order) {
    order.delivery_date_to_formatted = this.bRoot.moment(order.delivery_date_to).format("DD/MM/YYYY"); //eslint-disable-line
    order = await this.setDeliveryDateToAllItems(order);
    let validation_error = "";
    try {
      await this.validateHeaderDeliveryDate(order);
    } catch (error) {
      validation_error = error;
    }
    return { order: order, error: validation_error };
  }

  async deliveryUpdateDateFromChange(order) {
    order.delivery_date_from_formatted = this.bRoot.moment(order.delivery_date_from).format("DD/MM/YYYY"); //eslint-disable-line
    if (order.delivery_date_from) {
      order.delivery_date_to = this.bRoot
        .moment(order.delivery_date_from)
        .add(order.crop_campaign_parameters_object.delivery_period_size, "day")
        .format("YYYY-MM-DD");
    }
    return this.deliveryUpdateDateToChange(order);
  }

  async deliveryUpdateDateToChange(order) {
    order.delivery_date_to_formatted = this.bRoot.moment(order.delivery_date_to).format("DD/MM/YYYY"); //eslint-disable-line
    let validation_error = "";
    try {
      await this.validateDeliveryUpdateHeaderDate(order);
    } catch (error) {
      validation_error = error;
    }
    return { order: order, error: validation_error };
  }

  async setDeliveryDateFromAllItems(order) {
    for (let item of order.order_items || []) {
      item.delivery_date_from = order.delivery_date_from;
      item.delivery_date_from_fromatted = order.delivery_date_from_formatted;
    }
    return order;
  }

  async setDeliveryDateToAllItems(order) {
    for (let item of order.order_items || []) {
      item.delivery_date_to = order.delivery_date_to;
      item.delivery_date_to_fromatted = order.delivery_date_to_formatted;
    }
    return order;
  }

  async clearItems(order) {
    order.order_items = [];
    order = await this.addNewItem(order);
    order = await this.olpTotalize(order);
    return order;
  }

  async addNewItem(order) {
    let maxId = 0;
    if (order.order_items.length > 0) {
      // eslint-disable-next-line
      maxId  = order.order_items.reduce((acc, cur ) => Math.max(acc, cur.item_number), order.order_items[0].item_number);
    }
    let newItem = this.getNewItem();
    newItem.item_number = ++maxId;
    order.order_items.push(newItem);
    return order;
  }

  async deleteItem(order, item) {
    let index = order.order_items.findIndex(
      i => i.item_number === item.item_number
    );
    if (index != -1) {
      order.order_items.splice(index, 1);
      /* renum items */
      let item_number = 1;
      let new_items = order.order_items.map(new_item => {
        new_item.item_number = item_number;
        item_number += 1;
        return new_item;
      });
      order.order_items = new_items;
    }
    order = await this.olpTotalize(order);
    return order;
  }

  async itemChange(order, item_index, fieldName, object) {
    let new_item = null;
    let validation_error = null;
    let validate_delivery_dates = false;

    switch (fieldName) {
      case "inventory":
        new_item = await this.setItemProductFromInventory(
          order,
          order.order_items[item_index],
          object
        );
        new_item = await this.setSaleCondition(new_item, order);
        break;
      // eslint-disable-next-line
      case "unit_price_usd": case "leader_discount": case "company_discount":
        new_item = await this.itemRecalc(order.order_items[item_index], order);
        break;
      case "quantity":
        new_item = await this.itemQuantityChange(
          order.order_items[item_index],
          order
        );
        break;
      case "company_discount_motive":
        new_item = await this.setItemCompanyDiscountMotive(
          order.order_items[item_index],
          order,
          object
        );
        break;
      case "delivery_date_from":
        new_item = await this.itemDeliveryDateFromChange(
          order.order_items[item_index],
          order
        );
        validate_delivery_dates = true;
        break;
      case "delivery_date_to":
        new_item = await this.itemDeliveryDateToChange(
          order.order_items[item_index]
        );
        validate_delivery_dates = true;
        break;
      case "person":
        new_item = await this.itemPersonChange(
          order.order_items[item_index],
          object,
          order
        );
        break;
      default:
        new_item = order.order_items[item_index];
        break;
    }
    order.order_items.splice(item_index, 1, new_item);
    order = await this.setCampaignTotalQuantity(order);
    try {
      await this.validateOrderItemsMultiCrop(order);
      if (validate_delivery_dates) {
        await this.validateItemDeliveryDate(order, new_item);
      }
    } catch (error) {
      validation_error = error;
    }
    order = await this.olpTotalize(order);
    return { order: order, error: validation_error };
  }

  async setItemProductFromInventory(order, item, inventory) {
    let newItem = this.getNewItem();
    if (order.url) {
      newItem.order = order.url;
    }
    newItem.item_number = item.item_number;
    newItem.id = item.id;
    newItem.product = inventory.product;
    newItem.product_id = inventory.product_id;
    newItem.product_code = inventory.product_code;
    newItem.product_description = inventory.product_description;
    newItem.gauge = inventory.gauge;
    newItem.gauge_id = inventory.gauge_id;
    newItem.gauge_code = inventory.gauge_code;
    newItem.gauge_description = inventory.gauge_description;
    newItem.curing = inventory.curing;
    newItem.curing_id = inventory.curing_id;
    newItem.curing_code = inventory.curing_code;
    newItem.curing_description = inventory.curing_description;
    newItem.serial_number = inventory.serial_number;
    newItem.available_amount = inventory.available_amount;
    newItem.crop_id = inventory.crop_id;
    newItem.crop_description = inventory.crop_description;
    newItem.band = inventory.band;
    newItem.client = inventory.client;
    newItem.sector = inventory.sector;
    newItem.campaign = inventory.campaign;
    newItem.band_data.band_id = inventory.band_id;
    newItem.band_data.band_description = inventory.band_description;
    newItem.inventory_delivery_start_date = inventory.delivery_start_date;
    newItem.inventory_delivery_end_date = inventory.delivery_end_date;
    newItem.inventory_delivery_period_size = inventory.delivery_period_size;
    newItem.delivery_date_from = order.delivery_date_from;
    newItem.delivery_date_to = order.delivery_date_to;
    newItem.delivery_date_from_formatted = order.delivery_date_from_formatted;
    newItem.delivery_date_to_formatted = order.delivery_date_to_formatted;
    newItem.inventory_client = inventory.client;
    newItem.inventory_client_code = inventory.client_code;
    newItem.person = null;
    newItem.person_object = null;
    newItem.person_name = null;
    return newItem;
  }

  async setSaleCondition(item, order) {
    let dat = null;
    if (
      order.campaign_id &&
      order.client_object &&
      order.payment_condition &&
      item.product_id
    ) {
      let endpoint =
        "/data/sales_condition/" +
        order.campaign_id.toString() +
        "/" +
        order.date +
        "/" +
        order.client_object.category_id.toString() +
        "/" +
        (this.bRoot.isNullOrEmpty(order, "dealer_id") ? "0" : order.dealer_id.toString()) + //eslint-disable-line
        "/" +
        order.payment_condition_id.toString() +
        "/" +
        (order.total_quantity ? order.total_quantity.toString() : "0") +
        "/" +
        (order.advance_dispatch ? "1" : "0") +
        "/" +
        item.product_id.toString() +
        "/" +
        item.gauge_id.toString() +
        "/" +
        item.curing_id.toString();

      let response = await this.bRoot.search(endpoint);
      dat = Array.isArray(response.data) ? response.data[0] : response.data;
    }
    item.list_unit_price_usd = dat ? dat.list_unit_price_usd : 0;
    item.interest = dat ? dat.interest : 0;
    item.b1_discount = dat ? dat.b1_discount : 0;
    item.b2_discount = dat ? dat.b2_discount : 0;
    item.b3_discount = dat ? dat.b3_discount : 0;
    item.d1_discount = dat ? dat.d1_discount : 0;
    item.max_leader_discount = dat ? dat.max_leader_discount : 0;
    if (!dat) {
      item.net_unit_price_usd = 0;
    } else {
      item.net_unit_price_usd = Number(
        (
          item.list_unit_price_usd *
          (1 - item.b1_discount / 100) *
          (1 - item.b2_discount / 100) *
          (1 - item.b3_discount / 100) *
          (1 - item.d1_discount / 100)
        ).toFixed(4)
      );
    }
    item = await this.itemRecalc(item, order);
    return item;
  }

  async itemRecalc(item, order) {
    /*eslint-disable */
    if (!order.recalculating) {
      order.recalculating = true;
      if (order.document_object.disable_leader_discount) {
        item.transfer_price_usd = Number(
          (
            item.net_unit_price_usd *
            (1-(item.company_discount)/100) *
            (1+item.interest/100)
          ).toFixed(4)
        );
        item.leader_discount = 0;
      } else {
        switch (order.recalc_field) {
          case "unit_price_usd":
            item.unit_price_usd = Number(
              (
                item.net_unit_price_usd *
                (1-(item.company_discount+item.leader_discount)/100) *
                (1+item.interest/100)
              ).toFixed(4)
            );
            break;
          case "leader_discount":
            if (item.list_unit_price_usd != 0) {
              item.leader_discount = Number(
                (
                  (
                    100 * (
                      1 - (
                        (
                          (item.unit_price_usd / (1+item.interest/100)) / item.net_unit_price_usd
                        )
                      )
                    )
                  ) -
                  item.company_discount
                ).toFixed(6)
              );
            } else {
              item.lider_discount = 0;
            }
            break;
          case "company_discount":
            if (item.list_unit_price_usd != 0) {
              item.company_discount = Number(
                (
                  (
                    100 * (
                      1 - (
                        (
                          (item.unit_price_usd / (1+item.interest/100)) / item.net_unit_price_usd
                        )
                      )
                    )
                  ) -
                  item.leader_discount
                ).toFixed(6)
              );
            } else {
              item.company_discount = 0;
            }
          break;
        }
        item.transfer_price_usd = null;
      }
      if (this.bRoot.isNullOrEmpty(item, "company_discount", 0) !== 0) {
        item.company_discount_motive_required = true;
      } else {
        item.company_discount_motive_required = false;
        item = await this.setItemCompanyDiscountMotive(item, order);
      }
      item = await this.itemTotalComisionRecalc(item, order);
      order.recalculating = false;
      return item;
    }
    return item;
    /*eslint-enable */
  }

  async itemTotalComisionRecalc(item, order) {
    /* eslint-disable */
    if (order.document_object.disable_leader_discount) {
      item.spot_unit_price_usd = Number(item.unit_price_usd.toFixed(4));
      item.total_commission_usd = Number((item.unit_price_usd * item.quantity - item.transfer_price_usd * item.quantity ).toFixed(2));
      item.percentage_commission = Number((this.bRoot.isNullOrEmpty(item, "spot_unit_price_usd", 0) !== 0 ? (item.unit_price_usd - item.transfer_price_usd) / item.spot_unit_price_usd * 100 : 0).toFixed(4));
    } else {
      item.spot_unit_price_usd = Number((item.net_unit_price_usd * (1-(Number(item.company_discount)+Number(item.leader_discount))/100)).toFixed(4));
      item.total_commission_usd = Number((item.net_unit_price_usd * item.quantity * (item.max_leader_discount - item.leader_discount) / 100).toFixed(2));
      item.percentage_commission = Number((this.bRoot.isNullOrEmpty(item, "spot_unit_price_usd", 0) !== 0 ? item.net_unit_price_usd * (item.max_leader_discount - item.leader_discount) / item.spot_unit_price_usd : 0).toFixed(4));
      if (item.percentage_commission > item.max_leader_discount && order.recalc_field == "unit_price_usd") {
        let leader_discount = ((item.max_leader_discount * item.company_discount)/(100-item.max_leader_discount)); //eslint-disable-line
        if (leader_discount <= 0 || leader_discount > item.max_leader_discount || leader_discount == item.leader_discount) {
          return item;
        } else {
          item.leader_discount = Math.round(leader_discount*1000000)/1000000
          item.unit_price_usd = Number(
            (
              item.net_unit_price_usd *
              (1-(item.company_discount+item.leader_discount)/100) *
              (1+item.interest/100)
            ).toFixed(4)
          );
          item.spot_unit_price_usd = Number((item.net_unit_price_usd * (1-(Number(item.company_discount)+Number(item.leader_discount))/100)).toFixed(4));
          item.total_commission_usd = Number((item.net_unit_price_usd * item.quantity * (item.max_leader_discount - item.leader_discount) / 100).toFixed(2));
          item.percentage_commission = Number((this.bRoot.isNullOrEmpty(item, "spot_unit_price_usd", 0) !== 0 ? item.net_unit_price_usd * (item.max_leader_discount - item.leader_discount) / item.spot_unit_price_usd : 0).toFixed(4));
        }
      }
    }
    return item;
    /* eslint-enable */
  }

  async olpTotalize(order) {
    /* eslint-disable */
    const vatPercentage = 21;
    let newTotals = {
      subtotal: { sale: 0, commission: 0, net_sale: 0 },
      vat: { sale: 0, commission: 0, net_sale: 0 },
      total: { sale: 0, commission: 0, net_sale: 0 }
    };

    if (order.document_object.code == "OLP") {
      for (let item of order.order_items) {
        newTotals.subtotal.sale += this.round2(item.unit_price_usd * item.quantity);
        newTotals.subtotal.commission += this.round2((item.unit_price_usd - item.transfer_price_usd) * item.quantity);
        newTotals.subtotal.net_sale += this.round2(item.transfer_price_usd * item.quantity);        
      }
      newTotals.vat.sale = this.round2(newTotals.subtotal.sale * vatPercentage / 100);
      newTotals.vat.commission = this.round2((newTotals.subtotal.commission * vatPercentage) / 100);
      newTotals.vat.net_sale = this.round2(newTotals.subtotal.net_sale * vatPercentage / 100);

      newTotals.total.sale = newTotals.subtotal.sale + newTotals.vat.sale;
      newTotals.total.commission = newTotals.subtotal.commission + newTotals.vat.commission;
      newTotals.total.net_sale = newTotals.subtotal.net_sale + newTotals.vat.net_sale;
    }
    order.olp_totals = newTotals;
    return order;
    /* eslint-enable */
  }

  async setItemCompanyDiscountMotive(item, order, motive, motiveUrl) {
    if (!motive && motiveUrl) {
      try {
        this.bRoot.disableAlerts = true;
        motive = await this.bRoot.getObjectByURL(motiveUrl);
      } catch {
        motive = null;
      } finally {
        this.bRoot.disableAlerts = false;
      }
    }
    item.company_discount_motive_object = motive;
    item.company_discount_motive = motive ? motive.url : null;
    item.company_discount_motive_id = motive ? motive.id : 0;
    item.company_discount_motive_code = motive ? motive.code : null;
    item.disable_discount_limit = motive ? motive.disable_discount_limit : false; //eslint-disable-line
    item.company_discount_motive_description = motive ? motive.description : null; //eslint-disable-line
    return item;
  }

  async itemQuantityChange(item, order) {
    item = await this.itemTotalComisionRecalc(item, order);
    return item;
  }

  async itemDeliveryDateFromChange(item, object) {
    item.delivery_date_from_formatted = this.bRoot.moment(item.delivery_date_from).format("DD/MM/YYYY"); //eslint-disable-line
    item.delivery_date_to = this.bRoot.moment(item.delivery_date_from).add(object.crop_campaign_parameters_object.delivery_period_size, 'day').format("YYYY-MM-DD"); //eslint-disable-line
    item = await this.itemDeliveryDateToChange(item);
    return item;
  }

  async itemDeliveryDateToChange(item) {
    item.delivery_date_to_formatted = this.bRoot.moment(item.delivery_date_to).format("DD/MM/YYYY"); //eslint-disable-line
    return item;
  }

  async itemPersonChange(item, person, order) {
    if (person && order.document_object.requires_person) {
      item.person = person.person;
      item.person_object = person;
      item.person_name = person.name;
    } else {
      item.person = null;
      item.person_object = null;
      item.person_name = null;
    }
    return item;
  }

  async setSaleConditionAllItems(order) {
    let new_item = null;
    let index = 0;
    for (let item of order.order_items) {
      new_item = await this.setSaleCondition(item, order);
      order.order_items.splice(index, 1, new_item);
      index += 1;
    }
    return order;
  }

  getNewItem() {
    return {
      id: null,
      item_number: 0,
      product: null,
      product_id: 0,
      product_code: null,
      product_description: null,
      gauge: null,
      gauge_id: 0,
      gauge_code: null,
      gauge_description: null,
      curing: null,
      curing_id: 0,
      curing_code: null,
      curing_description: null,
      crop_id: 0,
      crop_description: null,
      quantity: 0,
      unit_price_usd: 0,
      leader_discount: 0,
      company_discount: 0,
      company_discount_motive_required: false,
      company_discount_motive: null,
      company_discount_motive_id: 0,
      company_discount_motive_code: null,
      company_discount_motive_description: null,
      comment: null,
      serial_number: null,
      band: null,
      band_data: { band_id: 0, band_description: null },
      campaign: null,
      sector: null,
      client: null,
      available_amount: null,
      interest: 0,
      b1_discount: 0,
      b2_discount: 0,
      b3_discount: 0,
      d1_discount: 0,
      max_leader_discount: 0,
      total_commission_usd: 0,
      percentage_commission: 0,
      list_unit_price_usd: 0,
      net_unit_price_usd: 0,
      spot_unit_price_usd: 0,
      inventory_delivery_start_date: null,
      inventory_delivery_end_date: null,
      inventory_delivery_period_size: 0,
      show_picker_from: false,
      show_picker_to: false,
      delivery_date_from: this.bRoot.moment().format("YYYY-MM-DD"),
      delivery_date_from_formatted: this.bRoot.moment().format("DD/MM/YYYY"),
      delivery_date_to: this.bRoot.moment().format("YYYY-MM-DD"),
      delivery_date_to_formatted: this.bRoot.moment().format("DD/MM/YYYY"),
      inventory_client: null,
      inventory_client_code: null
    };
  }

  async save(order, component) {
    order = await this.defaultValuesOrder(order);
    await this.validateOrder(order, component);

    let added = null;
    let configs = {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    };
    let formData = new FormData();
    for (const key in order) {
      if (
        Object.prototype.hasOwnProperty.call(order, key) &&
        key !== "invoice"
      ) {
        if (
          ["order_items", "invoice_file"].includes(key) ||
          typeof order[key] !== "object"
        ) {
          if (key == "order_items") {
            formData.append("order_items", JSON.stringify(order[key]));
          } else if (key == "invoice_file") {
            if (order[key].size > 0) {
              formData.append("invoice", order.invoice_file);
            }
          } else {
            formData.append(key, order[key]);
          }
        }
      }
    }

    if (order.url) {
      added = await this.bRoot.patch(formData, configs, order.url);
    } else {
      added = await this.bRoot.add("/data/orders", null, formData, configs);
    }
    return added;
  }

  async getDeliveryUpdate(orderId) {
    let endpoint =
      "/data/order_delivery_updates/by_order/" + orderId.toString();
    let response = await this.bRoot.search(endpoint, null, null, null, null);
    return this.normalizeDeliveryUpdate(response.data);
  }

  async saveDeliveryUpdate(payload) {
    let body = {
      order_id: payload.order_id,
      address: payload.address,
      postal_code_id:
        payload.postal_code_object && payload.postal_code_object.id
          ? payload.postal_code_object.id
          : payload.postal_code_id || null,
      delivery_contact_name: payload.delivery_contact_name,
      delivery_contact_phone: payload.delivery_contact_phone,
      internal_comments: payload.internal_comments,
      delivery_date_from: payload.delivery_date_from,
      delivery_date_to: payload.delivery_date_to
    };
    let saved = await this.bRoot.add(
      "/data/order_delivery_updates",
      null,
      body,
      null
    );
    return saved;
  }

  normalizeDeliveryUpdate(deliveryUpdate) {
    deliveryUpdate.postal_code = deliveryUpdate.postal_code_id;
    deliveryUpdate.internal_comments = deliveryUpdate.internal_comments || null;
    deliveryUpdate.postal_code_object = deliveryUpdate.postal_code_id
      ? {
          id: deliveryUpdate.postal_code_id,
          postal_code: deliveryUpdate.postal_code_code,
          description: deliveryUpdate.postal_code_description
        }
      : null;
    deliveryUpdate.order_items = [];
    deliveryUpdate.document_object = {
      inventory_has_client: !!deliveryUpdate.inventory_has_client
    };
    deliveryUpdate.crop_campaign_parameters_object = {
      delivery_period_size: deliveryUpdate.delivery_period_size || 0,
      delivery_start_date:
        deliveryUpdate.delivery_start_date || deliveryUpdate.date,
      delivery_end_date: deliveryUpdate.delivery_end_date || deliveryUpdate.date
    };
    deliveryUpdate.show_picker_from = false;
    deliveryUpdate.show_picker_to = false;
    return deliveryUpdate;
  }

  async changeState(order, state_code) {
    let endpoint =
      "/data/orders/change_state/" +
      order.campaign_id.toString() +
      "/" +
      order.id.toString() +
      "/" +
      state_code.toString() +
      "/";
    await this.bRoot.axios.post(endpoint);
  }

  async purgeState(campaign_code) {
    let endpoint = "/data/orders/purge_state/" + campaign_code.toString() + "/";
    await this.bRoot.axios.post(endpoint);
  }

  async defaultValuesOrder(order) {
    let defaultState = await this.bRoot.search(
      "/data/order_states",
      null,
      null,
      "default=true"
    );
    if (defaultState.data.results.length > 0) {
      order.state = defaultState.data.results[0].url;
    } else {
      order.state = null;
    }
    order.errors = null;
    if (order.document_object.sale_method) {
      order.sale_method = order.document_object.sale_method;
    } else {
      let sale_methods = await this.getSalesMethods();
      let nonDealerSaleMethodURL = null;
      let dealerSaleMethodURL = null;
      if (sale_methods.data.results) {
        sale_methods.data.results.forEach(element => {
          if (element.code === "6") {
            dealerSaleMethodURL = element.url;
          }
          if (element.code === "4") {
            nonDealerSaleMethodURL = element.url;
          }
        });
      }
      if (!order.dealer) {
        order.sale_method = nonDealerSaleMethodURL;
      } else {
        order.sale_method = dealerSaleMethodURL;
      }
    }
    order = await this.setCampaignPriorQuantity(order);
    return order;
  }

  async validateOrder(order, component) {
    /* Campo obligatorio Cliente */
    if (!order.client) {
      throw "Debe ingresar Cliente";
    }

    /* Validate Dealer is Empty client.category.code = "AGENTE" */
    if (!order.dealer && order.client_object.category_object.code !== "5") {
      throw {
        message:
          "Categoría de Cliente '" +
          order.client_object.category_object.description +
          "' incorrecta. Venta sin Agente solo puede efectuarse a clientes de la categoría Agente"
      };
    }

    /* Campo obligatorio Comercial */
    if (!order.commercial_person) {
      throw "No se pudo identificar al comercial logueado";
    }

    /* Campo campaña es obligatorio */
    if (!order.campaign) {
      throw "Debe ingresar Campaña";
    }

    /* Campo cultivo es obligatorio */
    if (!order.crop) {
      throw "Debe ingresar Cultivo";
    }

    /* Campo obligatorio condición de pago */
    if (!order.payment_condition) {
      throw "Debe ingresar Cóndición de Pago";
    }

    /* Validar Cliente */
    await this.validateClient(order);

    /* Validate broker field if requires */
    if (order.requires_broker && !order.broker) {
      throw {
        message:
          "Condición de pago '" +
          order.payment_condition_description +
          "' asociada al medio de pago '" +
          order.payment_condition_object.payment_form_object.description +
          "' requiere que se ingrese Corredor por Canje"
      };
    }

    /* Campo obligatorio Domicilio de Entrega */
    if (!order.document_object.inventory_has_client && !order.address) {
      throw "Debe ingresar Domicilio de Entrega";
    }

    /* Campo obligatorio código postal */
    if (!order.document_object.inventory_has_client && !order.postal_code) {
      throw "Debe ingresar Código Postal";
    }

    /* Evitar utilización de CP Capital Federal */
    if (
      !order.document_object.inventory_has_client &&
      !order.postal_code_allow_delivery
    ) {
      throw "Código postal inválido, no se pueden realizar envíos a Capital Federal";
    }

    /* Campo Obligatorio Estado */
    if (!order.state) {
      throw "No se ha definido estado por defecto, comuniquése con el administrador del sistema";
    }

    /* Validate items not empty */
    if (order.order_items.length === 0) {
      throw "El comprobante debe tener al menos un ítem";
    }

    /* validate order ítems */
    await this.validateOrderItems(order, component);
  }

  async validateClient(order) {
    /* Validar cliente habilitado para operaciones de contado */
    if (
      this.bRoot.isNullOrEmpty(order.client_object, "only_cash", false) &&
      !this.bRoot.isNullOrEmpty(order, "payment_condition_term")
    ) {
      throw "Cliente habilitado únicamente para operaciones de contado";
    }

    /* credit_lock y documentation_lock se controlan únicamente en remisión de mercadería */
    /* sale_base_lock no debería aplicarse en la OFC */
    if (
      this.bRoot.isNullOrEmpty(order.client_object, "sale_base_lock", false)
    ) {
      throw "El Cliente se encuentra Bloqueado por deber Base de Ventas, o adeudar Regalia Extendida a A.R.P.O.V. No se podran ingresar nuevos Pedidos";
    }
    if (
      this.bRoot.isNullOrEmpty(order.client_object, "judiciary_lock", false)
    ) {
      throw "El Cliente se encuentra INHIBIDO por estar en GESTIÓN JUDICIAL. No se podran ingresar nuevos Pedidos. Comunicarse con el analista CyC.";
    }
  }

  async validateOrderItemsMultiCrop(order) {
    let crop_id = order.crop_id;
    let crop_description = order.crop_description;

    for (let item of order.order_items) {
      if (
        crop_id !== this.bRoot.isNullOrEmpty(item, "crop_id", 0) &&
        item.crop_description
      ) {
        throw {
          message:
            "Item '" +
            item.item_number.toString() +
            "' cultivo '" +
            item.crop_description +
            "' difiere cultivo asignado a la Nota de Venta '" +
            crop_description +
            "'"
        };
      }
    }
  }

  async validateOrderItems(order, component) {
    await this.validateOrderItemsMultiCrop(order);
    if (
      parseInt(order.total_quantity) > parseInt(order.campaign_total_quantity)
    ) {
      let error_message =
        "Volúmen de venta acumulado de la campaña " +
        " inferior a la cantidad de bolsas asociada al descuento por volúmen seleccionado.";
      let popup_message =
        error_message +
        "Desea grabar ignorando la advertencia, no podrá solicitarse la facturación del pedido. ";
      let proceed = await component.$confirm(popup_message);
      if (!proceed) {
        throw {
          message: "Proceso cancelado por el usuario"
        };
      }
    }
    for (let item of order.order_items) {
      await this.validateOrderItem(order, item);
    }
  }

  async validateOrderItem(order, item) {
    /* eslint-disable */
    if (!item.product) {
      throw {
        message: "Item '" + item.item_number.toString() + "' ingrese Producto"
      };
    }
    if (this.bRoot.isNullOrEmpty(item, "quantity")) {
      throw {
        message: "Item '" + item.item_number.toString() + "' ingrese Cantidad"
      };
    }
    if (
      !this.bRoot.isNullOrEmpty(item, "company_discount") &&
      !item.company_discount_motive
    ) {
      throw {
        message:
          "Item '" +
          item.item_number.toString() +
          "' debe ingresar motivo del descuento LG"
      };
    }
    if (
      !order.document_object.allow_negative_leader_discount &&
      parseFloat(item.leader_discount) > parseFloat(item.max_leader_discount)
    ) {
      throw {
        message:
          "Item '" +
          item.item_number.toString() +
          "' Descuento Agente supera valor permitido (Max.Dto.Agente) " +
          item.max_leader_discount.toString()
      };
    }
    if (
      parseFloat(item.company_discount) > (100 - parseFloat(item.max_leader_discount))
    ) {
      throw {
        message:
          "Item '" +
          item.item_number.toString() +
          "' Descuento LG supera valor permitido (100 - Max.Dto.Agente) " +
          (100 - parseFloat(item.max_leader_discount)).toString()
      };
    }
    if (
      (1 - item.spot_unit_price_usd / item.list_unit_price_usd) * 100 > order.crop_campaign_parameters_object.max_discount
    ) {
      throw {
        message:
          "Item '" +
          item.item_number.toString() +
          "' Precio Contado '" +
          (item.spot_unit_price_usd).toFixed(4).toString() +
          "' debe ser superior al '" +
          (100 - order.crop_campaign_parameters_object.max_discount).toFixed(2).toString() +
          " %' del precio de lista '" +
          item.list_unit_price_usd.toString() +
          "': '" +
          (item.list_unit_price_usd * (100 - order.crop_campaign_parameters_object.max_discount) / 100).toFixed(4).toString() +
          "' la suma de Descuento Agente más Descuento LG debe ser igual o inferior a '" +
          ((1 - (item.list_unit_price_usd * (100 - order.crop_campaign_parameters_object.max_discount) / 100) / item.net_unit_price_usd )  *100).toFixed(6).toString() +
          "'"
      };
    }
    if (
      !this.bRoot.isNullOrEmpty(item, "company_discount") &&
      item.disable_discount_limit === false &&
      !order.document_object.allow_negative_leader_discount &&
      parseFloat(item.percentage_commission) > parseFloat(item.max_leader_discount)
    ) {
      throw {
        message:
          "Item '" +
          item.item_number.toString() +
          "', Comision Porcentual '" +
          parseFloat(item.percentage_commission).toFixed(2).toString() +
          " %' " +
          "supera Max.Dto.Agente '" +
          parseFloat(item.max_leader_discount).toFixed(2).toString() +
          "'"
      };
    }
    if (
      !order.document_object.allow_negative_leader_discount
      && parseFloat(item.leader_discount) < 0 
    ) {
      throw {
        message:
        "Item '" +
        item.item_number.toString() +
        "' descuento Agente debe ser mayor o igual a cero "
      };
    }
    if ( parseFloat(item.company_discount) < 0 ) {
      throw {
        message:
        "Item '" +
        item.item_number.toString() +
        "' descuento LG debe ser mayor o igual a cero "
      };
    }
    if ( parseFloat(item.unit_price_usd) <= 0 ) {
      throw {
        message:
        "Item '" +
        item.item_number.toString() +
        "' El precio de venta financiado debe ser mayor a cero "
      };
    }
    if (
      order.document_object.requires_person
      && parseFloat(item.transfer_price_usd) <= 0 
    ) {
      throw {
        message:
        "Item '" +
        item.item_number.toString() +
        "' El precio de transferencia debe ser mayor a cero "
      };
    }
    if (
      order.document_object.requires_person
      && parseFloat(item.unit_price_usd) < parseFloat(item.transfer_price_usd)
    ) {
      throw {
        message:
        "Item '" +
        item.item_number.toString() +
        "' El precio de venta financiado debe ser mayor al precio de transferencia "
      };
    }

    /* Validar consignación, si el comercial logueado es Agente o Asesor solo puede mover consignación de clientes "NO Consignatarios" o de Si Mismo */
    //this.$bRoot.appInfo.commercial_person.commercial_person_type.level
    if (
      order.document_object.inventory_has_client && 
      this.bRoot.appInfo.commercial_person.commercial_person_type.level > 2 &&
      item.inventory_client_code != this.bRoot.appInfo.commercial_person.client_code
    ) {
      throw "Las Ordene sobre inventario consignado a terceros deben ser generadas por un comercial interno (RTC/GTC)"
    }
    
    /* Validar dato persona */
    if (order.document_object.requires_person && !item.person) {
      throw {
        message: 
          "Item '"
          + item.item_number.toString()
          + "', ingrese comprador " 
      };
    }
    await this.validateItemDeliveryDate(order, item);
  }

  async validateItemDeliveryDate(order, item) {
    if (!order.document_object.inventory_has_client) {
      await this.validateDeliveryDate(
        order,
        item,
        item.inventory_delivery_start_date,
        item.inventory_delivery_end_date,
        item.delivery_date_from,
        item.delivery_date_to
      );
    }
  }

  async validateHeaderDeliveryDate(order) {
    if (!order.document_object.inventory_has_client) {
      await this.validateDeliveryDate(
        order,
        null,
        order.crop_campaign_parameters_object.delivery_start_date,
        order.crop_campaign_parameters_object.delivery_end_date,
        order.delivery_date_from,
        order.delivery_date_to
      );  
    }
  }

  async validateDeliveryUpdateHeaderDate(order) {
    if (!order.document_object.inventory_has_client) {
      await this.validateDeliveryUpdateDate(
        order.crop_campaign_parameters_object.delivery_start_date,
        order.crop_campaign_parameters_object.delivery_end_date,
        order.delivery_date_from,
        order.delivery_date_to
      );
    }
  }

  async validateDeliveryUpdateDate(
    delivery_start_date,
    delivery_end_date,
    delivery_date_from,
    delivery_date_to
  ) {
    if (delivery_date_to < delivery_date_from) {
      throw {
        message:
          "La fecha de entrega hasta no puede ser anterior a la fecha de entrega desde"
      };
    }
    if (delivery_date_from < delivery_start_date) {
      throw {
        message:
          "La fecha de entrega desde no puede ser anterior a la fecha de inicio de entregas de la campaña " +
          this.bRoot.moment(delivery_start_date).format("DD/MM/YYYY")
      };
    }
    if (delivery_date_to > delivery_end_date) {
      throw {
        message:
          "La fecha de entrega hasta no puede ser posterior a la fecha de finalización de entregas de la campaña " +
          this.bRoot.moment(delivery_end_date).format("DD/MM/YYYY")
      };
    }
  }

  async validateDeliveryDate(order, item, inventory_delivery_start_date, inventory_delivery_end_date, delivery_date_from, delivery_date_to) {
    if (delivery_date_from < order.date) {
      throw {
        message:
          (item ? "Item '" + item.item_number.toString() : "") +
          "' La fecha de entrega desde no puede ser anterior a la fecha del pedido"
      };
    }
    if (delivery_date_to < delivery_date_from) {
      throw {
        message:
        (item ? "Item '" + item.item_number.toString() : "") +
          "' La fecha de entrega hasta no puede ser anterior a la fecha de entrega desde"
      };
    }
    if (delivery_date_from < inventory_delivery_start_date) {
      throw {
        message:
          (item ? "Item '" + item.item_number.toString() : "") +
          "' La fecha de entrega desde no puede ser anterior a la fecha de inicio de entregas de la campaña " +
          this.bRoot.moment(inventory_delivery_start_date).format("DD/MM/YYYY")
      };
    }
    if (delivery_date_to > inventory_delivery_end_date) {
      throw {
        message:
          (item ? "Item '" + item.item_number.toString() : "") +
          "' La fecha de entrega hasta no puede ser posterior a la fecha de finalización de entregas de la campaña " +
          this.bRoot.moment(inventory_delivery_end_date).format("DD/MM/YYYY")
      };
    }
  }
  /* eslint-enable */

  round2(value) {
    return Math.round(value * 100) / 100;
  }
}
